import { Button, Pagination } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ICompanyData } from '../../../../../shared/types/company';
import { useCustomSearch } from '../../../../../shared/hook/useCustomSearch';
import { cleanParams } from '../../../../../shared/utils/cleanParams';
import * as C from '../../../../ui/common/CommonStyles';
import CustomSearch from '../../../../ui/search/customSearch';
import CompanyRegModal from '../Modal/CompanyRegModal';
import ViewModal from '../Modal/ViewModal';
import CompanyListTable from './CompanyListTable';

export default function Company() {
  const [opened, { open, close }] = useDisclosure(false);
  const [isEdit, setIsEdit] = useState(false);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [editItem, setEditItem] = useState<ICompanyData | null>(null);
  const [searchParams, setSearchParams] = useSearchParams('');
  const page = searchParams.get('page') || '1';
  const size = searchParams.get('size') || '10';
  const searchWordUrl = searchParams.get('keyword') || '';
  const searchTypeUrl = searchParams.get('searchType') || 'name';
  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({ initType: 'name' });

  const [viewModalOpened, { open: openViewModal, close: closeViewModal }] = useDisclosure(false);
  const [company, setCompany] = useState({
    companyName: '',
    companyId: '',
  });

  // // 거래처 수정 모달 열기
  // const openEditModal = (data: ICompanyData) => {
  //   if (!isEdit) setIsEdit(true);
  //   open();
  //   setEditItem(data);
  // };

  // 모달 닫기 시 초기화
  const closeModal = () => {
    setIsEdit(false);
    setEditItem(null);
    close();
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">거래처 관리</div>
      </C.TitleBox>
      <C.ListBox>
        <C.ControlBox>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchTypeUrl}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={[
              { value: 'name', label: '거래처명' },
              { value: 'repName', label: '대표자명' },
            ]}
          />
          <Button onClick={open} color="secondary.5" variant="filled">
            거래처 등록
          </Button>
        </C.ControlBox>
        <CompanyListTable
          page={page}
          size={size}
          searchTypeUrl={searchTypeUrl}
          searchWordUrl={searchWordUrl}
          setTotalPage={setTotalPage}
        />
        <C.PaginationBox>
          <Pagination
            total={totalPage}
            onChange={(value) => {
              const currentParams = Object.fromEntries(searchParams.entries());
              setSearchParams(
                cleanParams({
                  ...currentParams,
                  page: String(value),
                  searchType: searchTypeUrl || '',
                  keyword: searchWordUrl || '',
                }),
              );
            }}
            value={Number(page)}
          />
        </C.PaginationBox>
      </C.ListBox>
      <CompanyRegModal opened={opened} closeModal={closeModal} isEdit={isEdit} data={editItem} />
      {viewModalOpened && <ViewModal opened={viewModalOpened} onClose={closeViewModal} company={company} />}
    </div>
  );
}
